import { FC } from "react";
import { NotificationDto } from "@/modules/notification-center/dtos";
import { DefaultNotificationTemplate } from "@/modules/notification-center/components/notification/notification-templates/default-notification-template";
import { CommentNotificationTemplate } from "@/modules/notification-center/components/notification/notification-templates/comment-notification-template";

export type NotificationTemplateComponent = FC<{
  notification: NotificationDto;
}>;

enum CustomNotificationTemplateName {
  BULK_LEAD_ASSIGNED = "bulk lead assigned",
  NEW_MARKET_UPDATE = "new market update",
  NEGATIVE_RATING = "negative rating",
  COMMENT_MENTION = "comment mention",
  COMMENT_ADDED = "comment added",
}

const templateComponentMap: Record<
  CustomNotificationTemplateName,
  (notification: NotificationDto) => NotificationTemplateComponent
> = {
  [CustomNotificationTemplateName.BULK_LEAD_ASSIGNED]:
    (notification) => (props) => (
      <DefaultNotificationTemplate
        {...props}
        linkLabel="View leads"
        notification={notification}
      />
    ),

  [CustomNotificationTemplateName.NEW_MARKET_UPDATE]:
    (notification) => (props) => (
      <DefaultNotificationTemplate
        {...props}
        linkLabel="View update"
        notification={notification}
      />
    ),

  [CustomNotificationTemplateName.NEGATIVE_RATING]:
    (notification) => (props) => (
      <DefaultNotificationTemplate
        {...props}
        linkLabel="View review"
        notification={notification}
      />
    ),

  [CustomNotificationTemplateName.COMMENT_MENTION]:
    (notification) => (props) => (
      <CommentNotificationTemplate {...props} notification={notification} />
    ),

  [CustomNotificationTemplateName.COMMENT_ADDED]: (notification) => (props) => (
    <CommentNotificationTemplate {...props} notification={notification} />
  ),
};

export const NotificationTemplateFactory = (
  notification: NotificationDto,
): NotificationTemplateComponent => {
  const key =
    notification?.SystemTemplate?.name?.toLowerCase() as CustomNotificationTemplateName;

  const templateFn = templateComponentMap[key];
  if (templateFn) return templateFn(notification);

  return (props) => (
    <DefaultNotificationTemplate {...props} notification={notification} />
  );
};
